import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { useEffect, useState } from "react";
import { Trans } from "react-i18next";
import { emptyTeam, Team } from "../../../../interfaces/team";
import { deleteTeam, getTeamSingle } from "../../../../services/team";
import { LoadingSpinner } from "../../../general/loading-spinner";

interface AdminTeamDeleteProps {
    id: number;
    onDelete: CallableFunction;
    onClose: CallableFunction;
}

export function AdminTeamDelete(props: AdminTeamDeleteProps) {
    const [team, setTeam] = useState<Team>(emptyTeam);

    const handleDelete = () => {
        deleteTeam(props.id)
            .then(response => {
                if (response.data == 0) {
                    alert(t("Team cannot be deleted. Athletes or staff are related."));
                    props.onClose();
                } else {
                    props.onDelete(props.id);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }

    const handleClose = () => {
        props.onClose();
    }

    useEffect(() => {
        getTeamSingle(props.id)
            .then(response => {
                setTeam(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);

    return (
        <Modal className="admin-team-delete-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("delete_team") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                { team.id == 0 && 
                    <LoadingSpinner />
                }
                { team.id != 0 &&
                    <Form onSubmit={ handleDelete }>
                        <div className="fields">
                            <Trans i18nKey="delete_team_message"
                                values={{
                                    team_name: team.name
                                   }} />
                        </div>
                        <div className="actions">
                            <Button type="submit" variant="primary">
                                { t("Delete") }
                            </Button>
                            <Button variant="secondary" onClick={ handleClose }>
                                { t("Close") }
                            </Button>
                        </div>
                    </Form>
                }
            </Modal.Body>
        </Modal>
    );
}
